// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"201":"entry","966":"login"}[chunkId] + "." + {"201":"bbeed696","966":"9982072d"}[chunkId] + ".js";
};